<template>
  <div v-if="endLevel !== currentLevel">
    <div v-for="node in tree" :key="node.tpId" :class="{ 'pl-15': isSub }">
      <div
        class="tree-node fb fb-main-between fb-cross-center font-32"
        :class="{ bb: node.childs && node.childs.length > 0 }"
        @click="handlerToOpenNode(node)"
      >
        <span>{{ node.name }}</span>
        <span v-if="node.isNeedLoadChilds">
          <i v-if="node.isOpen" class="iconfont c-191F25-28">&#xe610;</i>
          <i v-else class="iconfont c-191F25-28">&#xe613;</i>
        </span>
      </div>
      <common-school-tree
        v-if="node.childs && node.childs.length > 0"
        v-show="node.isOpen"
        :parent="node"
        :current-level="node.level + 1"
        :end-level="endLevel"
        :is-sub="true"
        :tree-nodes="node.childs"
        :default-selected-node-id="selectedNodeTpId"
        @change="handlerChangeNode"
      ></common-school-tree>
    </div>
  </div>
  <div v-else class="fb fb-main-start fb-wrap pt-8" :class="{ 'pl-15': isSub }">
    <div
      v-for="node in tree"
      :key="node.tpId"
      class="node-box"
      :selected="node.tpId === selectedNodeTpId"
      @click="handlerToSelectedNode(node)"
    >
      {{ node.name }}
    </div>
  </div>
</template>

<script>
import API from '../api'

export default {
  name: 'commonSchoolTree',
  components: {},
  props: {
    defaultSelectedNodeId: String,
    parent: {
      type: Object,
      default: null
    },
    endLevel: {
      type: Number,
      default: 5
    },
    currentLevel: {
      type: Number,
      default: 1
    },
    isSub: {
      type: Boolean,
      default: false
    },
    treeNodes: Array
  },
  data() {
    return {
      tree: [],
      selectedNodeTpId: ''
    }
  },
  computed: {},
  watch: {
    defaultSelectedNodeId(val) {
      this.selectedNodeTpId = val
    },
    treeNodes(val) {
      this.tree = val
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      this.selectedNodeTpId = this.defaultSelectedNodeId || ''
      if (!this.isSub && !this.treeNodes) {
        this.fetchGetCapmusList()
          .then(res => {
            this.tree = res
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        this.tree = this.treeNodes
      }
    },
    handlerToOpenNode(node) {
      node.isOpen = !node.isOpen
      if (node.isNeedLoadChilds === true && node.isLoaded === false) {
        switch (node.level) {
          case 1:
            // 获取学段列表
            this.fetchGetPeriodList(node.tpId)
              .then(res => {
                node.childs = res
                node.isLoaded = true
                if (!res || res.length === 0) {
                  node.isNeedLoadChilds = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
            break
          case 2:
            // 获取年级列表
            this.fetchGetGradeList(node.tpId)
              .then(res => {
                node.childs = res
                node.isLoaded = true
                if (!res || res.length === 0) {
                  node.isNeedLoadChilds = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
            break
          case 3:
            // 获取班级列表
            this.fetchGetClassList(node.tpId)
              .then(res => {
                node.childs = res
                node.isLoaded = true
                if (!res || res.length === 0) {
                  node.isNeedLoadChilds = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
            break
          case 4:
            // 获取学生列表
            this.fetchGetStudentList(node.tpId)
              .then(res => {
                node.childs = res
                node.isLoaded = true
                if (!res || res.length === 0) {
                  node.isNeedLoadChilds = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
            break
          default:
            break
        }
      }
    },
    handlerToSelectedNode(node) {
      let _node = { ...node }
      this.methodGetParentInfo(_node)
      this.$emit('change', _node)
    },
    // 事件冒泡
    handlerChangeNode(node) {
      let _node = { ...node }
      this.methodGetParentInfo(_node)
      this.selectedNodeTpId = _node.tpId
      this.$emit('change', _node)
    },
    // 获取校区列表
    fetchGetCapmusList() {
      return new Promise((resolve, reject) => {
        API.dingGetCapmusList({})
          .then(res => {
            let _capmusList =
              res.filter(respond => {
                return (
                  respond.tpId ===
                  window.localStorage.getItem('currentCapmusId')
                )
              }) || []
            _capmusList.forEach(item => {
              item.level = 1
              item.isOpen = false
              item.isNeedLoadChilds = !(this.endLevel === item.level)
              item.isLoaded = false
              item.childs = []
            })
            resolve(_capmusList)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 获取学段列表
    fetchGetPeriodList(tpCapmusId) {
      return new Promise((resolve, reject) => {
        let _postData = {
          tpCapmusId: tpCapmusId
        }
        API.dingGetPeriodList(_postData)
          .then(res => {
            let _periodList = res || []
            _periodList.forEach(item => {
              item.level = 2
              item.isOpen = false
              item.isNeedLoadChilds = !(this.endLevel === item.level)
              item.isLoaded = false
              item.childs = []
            })
            resolve(_periodList)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 获取年级列表
    fetchGetGradeList(tpPeriodId) {
      return new Promise((resolve, reject) => {
        let _postData = {
          tpPeriodId: tpPeriodId
        }
        API.dingGetGradeList(_postData)
          .then(res => {
            let _gradeList = res || []
            _gradeList.forEach(item => {
              item.level = 3
              item.isOpen = false
              item.isNeedLoadChilds = !(this.endLevel === item.level)
              item.isLoaded = false
              item.childs = []
            })
            resolve(_gradeList)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 获取班级列表
    fetchGetClassList(tpGradeId) {
      let _pageSize = 30
      let _postData = {
        tpGradeId: tpGradeId,
        pageNo: 0,
        pageSize: _pageSize
      }
      return new Promise(async (resolve, reject) => {
        let _classList = []
        let _isGetAll = false
        while (!_isGetAll) {
          _postData.pageNo++
          let res = await API.dingGetClassList(_postData)
          _classList = _classList.concat(res.data || [])
          if (res.data && res.data.length < _pageSize) {
            _isGetAll = true
          }
        }
        _classList.forEach(item => {
          item.level = 4
          item.isOpen = false
          item.isNeedLoadChilds = !(this.endLevel === item.level)
          item.isLoaded = false
          item.childs = []
        })
        resolve(_classList)
      })
    },
    // 获取学生列表
    fetchGetStudentList(tpClassId) {
      let _pageSize = 30
      let _postData = {
        tpClassId: tpClassId,
        pageNo: 0,
        pageSize: _pageSize
      }
      return new Promise(async (resolve, reject) => {
        let _studentList = []
        let _isGetAll = false
        while (!_isGetAll) {
          _postData.pageNo++
          let res = await API.dingGetStudentList(_postData)
          _studentList = _studentList.concat(res.data || [])
          if (res.data && res.data.length < _pageSize) {
            _isGetAll = true
          }
        }
        _studentList.forEach(item => {
          item.level = 5
          item.isOpen = false
          item.isNeedLoadChilds = !(this.endLevel === item.level)
          item.isLoaded = false
          item.childs = []
        })
        resolve(_studentList)
      })
    },
    methodGetParentInfo(node) {
      if (this.parent) {
        switch (this.parent.level) {
          case 1:
            node.tpCapmusId = this.parent.tpId
            node.capmusId = this.parent.deptId
            node.capmusName = this.parent.name
            break
          case 2:
            node.tpPeriodId = this.parent.tpId
            node.periodId = this.parent.deptId
            node.periodName = this.parent.name
            break
          case 3:
            node.tpGradeId = this.parent.tpId
            node.gradeId = this.parent.deptId
            node.gradeName = this.parent.name
            break
          case 4:
            node.tpClassId = this.parent.tpId
            node.classId = this.parent.deptId
            node.className = this.parent.name
            break
          default:
            break
        }
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.tree-node {
  height: 60px;
  // border-bottom: 1px solid rgba(#191f25, 0.12);
  color: rgba(#191f25, 0.56);
}
.node-box {
  width: 30%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: 6px 3% 6px 0;
  padding: 0 6px;
  background: #f4f4f4;
  border: 4px;
  @include text-ellipsis;

  &[selected='selected'] {
    background: rgba(#006afe, 0.17);
  }
}
</style>
